var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileSaveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.7026 3.23214L6.96524 0.498123C6.6467 0.179568 6.21453 0.000396352 5.76375 0H3.96718V3.39629H6.80089C6.9512 3.39629 7.09535 3.45593 7.20163 3.56208C7.30792 3.66824 7.36763 3.81221 7.36763 3.96234C7.36763 4.11247 7.30792 4.25644 7.20163 4.3626C7.09535 4.46875 6.9512 4.52839 6.80089 4.52839H3.40044C3.25014 4.52839 3.10598 4.46875 2.9997 4.3626C2.89341 4.25644 2.8337 4.11247 2.8337 3.96234V0H1.70022C1.2493 0 0.816837 0.178911 0.497984 0.497375C0.17913 0.81584 0 1.24777 0 1.69815V8.49073C0 8.94111 0.17913 9.37304 0.497984 9.6915C0.816837 10.01 1.2493 10.1889 1.70022 10.1889H2.8337V7.92468C2.8337 7.62443 2.95312 7.33648 3.16569 7.12417C3.37826 6.91186 3.66657 6.79258 3.96718 6.79258H6.23415C6.53477 6.79258 6.82307 6.91186 7.03564 7.12417C7.24821 7.33648 7.36763 7.62443 7.36763 7.92468V10.1889H8.50111C8.95204 10.1889 9.3845 10.01 9.70335 9.6915C10.0222 9.37304 10.2013 8.94111 10.2013 8.49073V4.43216C10.2009 3.98194 10.0215 3.5503 9.7026 3.23214Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileSaveIcon);
export default __webpack_public_path__ + "static/media/profile-save-icon.5a8e8ac764a9b71eb4b9198878b0f420.svg";
export { ForwardRef as ReactComponent };